export default __webpack_public_path__ + "static/media/soh_edit.583d8940.svg";